export const OrderConstants = {
    GET_ALL_ORDER_REQUEST:'GET_ALL_ORDER_REQUEST',
    GET_ALL_ORDER_SUCCESS:'GET_ALL_ORDER_SUCCESS',
    GET_ALL_ORDER_FAILURE:'GET_ALL_ORDER_FAILURE',  
    ORDER_SEARCH_REQUEST : 'ORDER_SEARCH_REQUEST',

    MARK_ORDER_REQUEST:'MARK_ORDER_REQUEST',
    MARK_ORDER_SUCCESS:'MARK_ORDER_SUCCESS',
    MARK_ORDER_FAILURE:'MARK_ORDER_FAILURE',


    MARK_ORDER_ACCEPTED_REQUEST:'MARK_ORDER_ACCEPTED_REQUEST',
    MARK_ORDER_ACCEPTED_SUCCESS:'MARK_ORDER_ACCEPTED_SUCCESS',
    MARK_ORDER_ACCEPTED_FAILURE:'MARK_ORDER_ACCEPTED_FAILURE',
    
    
         
};
